import { SectionTabItem } from 'components/Layout/MobileShell/SectionTabs';

// Abas de seção do mobile de Administração — lista plana das telas de
// Administração (sem hubs intermediários). Flux e Windx apontam direto para
// suas telas-folha (Sobre e Modelos), igual às demais seções.
const ADMIN_SECTION_TABS: SectionTabItem[] = [
  { title: 'Usuários', path: '/admin/users' },
  { title: 'Empresas', path: '/admin/companies' },
  { title: 'Financeiro', path: '/admin/financial' },
  { title: 'Sobre', path: '/admin/flux/about' },
  { title: 'Modelos', path: '/admin/windx/models' },
];

export default ADMIN_SECTION_TABS;
